import { apiClient } from "api/ApiClient";
import ApiEndpoints from "api/ApiEndpoints";

export const acceptTerms = () => {
  return apiClient
    .post(ApiEndpoints.ACCEPT_TERMS)
    .then(() => true)
    .catch(() => false);
};
